import { getUnificationParams } from "../../utils";
import InfoIcon from "../../assets/images/icons/alert/info.svg?react";
import styles from "./UnificationCard.module.scss";

const UnificationCard = () => {
  const { container, headerContainer, infoIcon, infoContainer } = styles;

  return (
    <div className={container}>
      <div className={headerContainer}>
        <InfoIcon className={infoIcon} />
        <p>Unificación de cuentas</p>
      </div>
      <p>La cuenta se asociará con la siguiente cuenta de Allaria:</p>
      <div className={infoContainer}>
        <p>#{getUnificationParams().accountId}</p>
        <p>{getUnificationParams().accountName}</p>
      </div>
    </div>
  );
};

export default UnificationCard;
